module.exports = __webpack_public_path__ + "img/guide_text1.cd195ef3.png";